module.exports = __webpack_public_path__ + "static/media/50n.43b88438.svg";